<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
  </div>
  <mat-sidenav-container>
    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg">

        <div class="content pos-relative m-30 flex flex-col">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="sourceKey"
                                   sortFieldKey="Name"
                                   (valueChanged)="onGridCellValueChange($event)">
            </particle-virtual-grid>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>

